<template>
  <v-card class="regie-card d-flex fill-height">
    <v-row no-gutters class="fill-height ma-0">
      <v-col cols="6" class="pa-0 regie-image-col">
        <div class="regie-image-wrap">
          <img :src="imageSrc" :alt="name" class="regie-image" />
        </div>
      </v-col>

      <v-col cols="6" class="d-flex flex-column pa-0">
        <div class="regie-content pa-3">
          <h4 class="mb-2"><b>{{ name }}</b></h4>
          <p class="caption mb-0">
            <slot></slot>
          </p>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
    export default {
        name: "RegieCard",
        props: {
            name: String,
            imageSrc: String
        }
    }
</script>

<style scoped>
.regie-card {
    height: 100%;
    overflow: hidden;
}

.regie-image-col {
    min-height: 180px;
}

.regie-image-wrap {
    height: 100%;
    min-height: 180px;
    overflow: hidden;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

.regie-image {
    display: block;
    width: 100%;
    height: 100%;
    min-height: 180px;
    object-fit: cover;
    object-position: center top;
}

.regie-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 100%;
}
</style>